import React from "react";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ }) => {
    return (
        <>
            <Box 
                style={{
                    position: 'absolute', 
                    left: '50%', 
                    top: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%',
                    minHeight: '120px',
                    zIndex: 1300, // Explicit layout safety placement layering index
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    backdropFilter: 'blur(3px)', // Soft ambient background content isolation blur
                    transition: 'all 0.3s ease-in-out',
                    borderRadius: 'inherit'
                }}
            >
                <CircularProgress 
                    size={42}
                    thickness={4.5}
                    sx={{
                        color: '#1976d2', // --- CORPORATE BLUE BRAND ACCENT TOKEN ---
                        strokeLinecap: 'round',
                        animationDuration: '650ms', // Smoothed high-performance acceleration transition profile
                        '& .MuiCircularProgress-circle': {
                            strokeDasharray: '80px, 200px'
                        }
                    }}
                />
            </Box>
        </>
    );
};

export default Loader;